import {
    createPromoProduct,
    deletePromoProduct,
    getPromoProduct,
    getPromoProductById,
    updatePromoProduct,
    updateActive,
    getPromoProductAll,
} from '../services/PromoProductService';
import useAlert from '../../../shared/hooks/useAlert';
import { useEffect, useState } from 'react';

export const usePromoProduct = () => {

    const [promoProduct, setPromoProduct] = useState([]);
    const [promoProductAll, setPromoProductAll] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { alert, showAlert } = useAlert();

    const fetchPromoProductAll = async () => {
        try {
            setLoading(true);
            const response = await getPromoProductAll();
            setPromoProductAll(response.data);

            setLoading(false);
        } catch (err) {
            setError('Failed to fetch categories');
        } finally {
            setLoading(false);
        }
        setLoading(false);
    };

    const fetchPromoProduct = async () => {
        try {
            setLoading(true);
            const response = await getPromoProduct();
            setPromoProduct(response.data);

            setLoading(false);
        } catch (err) {
            setError('Failed to fetch categories');
        } finally {
            setLoading(false);
        }
        setLoading(false);
    };

    const fetchPromoProductById = async (id) => {
        try {
            const response = await getPromoProductById(id);
            setPromoProduct(promoProduct.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update typeProduct');
        }
    };

    const addPromoProduct = async (promoProduct) => {
        // console.log(promoProduct)
        try {
            const response = await createPromoProduct(promoProduct);
            setPromoProduct([...promoProduct, response.data]);
            showAlert('Created successfully!', 'success');
        } catch {
            setError('Failed to add categories');
            showAlert('Error creating', 'danger');
        }
    };

    const editPromoProduct = async (id, updatedPromoProduct) => {
        // console.log(updatedPromoProduct.isActive)
        try {
            const response = await updatePromoProduct(id, updatedPromoProduct);
            console.log(response)
            setPromoProduct(promoProduct.map(p => (p.id === id ? response.data : p)));
            showAlert('Edited successfully!', 'success');
        } catch {
            setError('Failed to update categories');
            showAlert('Error creating', 'danger');
        }
    };

    const updateOnActive = async (id, updatedStatus) => {
        try {
            setLoading(true);
            const response = await updateActive(id, updatedStatus);
            setPromoProduct(promoProduct.map(p => (p.id === id ? response.data : p)));
            setLoading(false);
            showAlert('Edited successfully!', 'success');
        } catch {
            setError('Failed to update categories');
            showAlert('Error creating', 'danger');
        }
    };

    const removePromoProduct = async (id) => {
        try {
            await deletePromoProduct(id);
            setPromoProduct(promoProduct.filter(p => p.id !== id));
            showAlert('Remove successfully!', 'success');
        } catch {
            setError('Failed to delete categories');
            showAlert('Error creating', 'danger');
        }
    };

    useEffect(() => {
        fetchPromoProductAll();
        fetchPromoProduct();
    }, []);

    return {
        loading, error, alert,
        promoProduct,
        promoProductAll,
        fetchPromoProductAll,
        fetchPromoProduct,
        fetchPromoProductById,
        addPromoProduct,
        editPromoProduct,
        removePromoProduct,
        updateOnActive
    };
}
